import { BackgroundViewHelper } from "@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper";
import { GetterTree } from "vuex";
import { BackgroundViewState } from "../types/BackgroundViewState";
import { RootState } from "../types/RootState";

const getters: GetterTree<BackgroundViewState, RootState> = {
    activeBroadcastView({ broadcastQue }) {
        return BackgroundViewHelper.getActiveBroadcastView(broadcastQue);
    }
};

export { getters }
